<template>
  <div class="flex h-screen overflow-hidden app-bg">
    <aside
      :class="[
        'bg-white1 transition-all duration-300 ease-in-out z1 sidebar',
        'h-screen flex flex-col ',
        isCollapsed ? 'w-16' : 'w-64',
      ]"
    >
      <!-- Header -->
      <div
        class="flex items-center justify-between p-4 border-b border-white border-opacity-20 flex-shrink-0 relative dark:border-dashed"
      >
        <!--h2 v-if="!isCollapsed" class="m-0 text-xl font-semibold"-->
        <h2 class="m-0 text-xl font-semibold">
          <img v-if="isCollapsed" src="../../public/img/logo/logo-icon.png" alt="ClevuhCore" class="blogo res">
          <img v-if="!isCollapsed" src="../../public/img/logo/logo-dark.png" alt="ClevuhCore" class="dlogo">
          <img v-if="!isCollapsed" src="../../public/img/logo/logo-light.png" alt="ClevuhCore" class="llogo">
        </h2>

        <button
          @click="toggleSidebar"
          class="p-2 rounded-xl transition-colors cursor-pointer border-none absolute togbtn bg-white1"
        >
          <svg
            v-if="!isCollapsed"
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
          </svg>
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

     

      <!-- Scrollable Menu -->
      <nav class="flex-1 overflow-y-auto py-2 sidebar-scroll">
        <ul class="list-none m-0 p-0">
          <template v-for="(item, index) in visibleMenuItems">

            <!-- Single Link -->
            <li v-if="item.type === 'link'" :key="item.id || item.to || index">
              <router-link
                :to="item.to"
                class="flex items-center px-4 py-3 transition-colors "
                :class="{
                  'justify-center': isCollapsed,
                  'pastal-1': isNavLinkActive(item),
                }"
              >
                <span class="flex items-center justify-center w-5 h-5 min-w-[1.25rem] flex-shrink-0">
                  <svg
                    v-if="item.icon && ICONS[item.icon]"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2" :d="ICONS[item.icon]" />
                  </svg>
                </span>
                <span v-if="!isCollapsed" class="ml-3">
                  {{ item.label }}
                </span>
              </router-link>
            </li>

            <!-- Group -->
            <li v-else-if="item.type === 'group'" :key="item.id || index">
              <button
                type="button"
                @click="toggleMenu(item.id)"
                class="w-full flex items-center px-4 py-3 transition-colors bg-transparent border-none cursor-pointer"
                :class="{
                  'justify-center': isCollapsed,
                  'pastal-1': isMenuOpen(item.id),
                }"
              >
                <span class="flex items-center justify-center w-5 h-5 min-w-[1.25rem] flex-shrink-0">
                  <svg
                    v-if="item.icon && ICONS[item.icon]"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2" :d="ICONS[item.icon]" />
                  </svg>
                </span>

                <span v-if="!isCollapsed" class="ml-3 flex-1 text-left">
                  {{ item.label }}
                </span>

                <svg
                  v-if="!isCollapsed"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 transition-transform"
                  :class="{ 'rotate-90': isMenuOpen(item.id) }"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="2" :d="ICONS.chevron" />
                </svg>
              </button>

              <!-- Submenu -->
              <ul
                v-if="!isCollapsed && isMenuOpen(item.id)"
                class="list-none m-0 p-0 border-l-2 border-white border-opacity-20 ml-4 my-1"
              >
                <template v-for="(child, childIdx) in item.children">

                  <!-- Section -->
                  <template v-if="child.type === 'section'">
                    <li v-if="child.label" :key="'section-label-' + childIdx" class="px-3 pt-3 pb-1">
                      <span class="text-xs uppercase tracking-wide text-opacity-70">
                        {{ child.label }}
                      </span>
                    </li>

                    <li
                      v-for="(sub, subIdx) in visibleSectionItems(child.items)"
                      :key="'section-' + childIdx + '-' + subIdx"
                    >
                      <router-link
                        :to="sub.to"
                        class="flex items-center w-full pl-4 pr-3 py-2.5 text-sm transition-colors "
                        active-class="pastal-1"
                      >
                        {{ sub.label }}
                      </router-link>
                    </li>
                  </template>

                  <!-- Direct link inside group -->
                  <li
                    v-else-if="child.to && canShowByRole(child)"
                    :key="'child-' + childIdx"
                  >
                    <router-link
                      :to="child.to"
                      class="flex items-center w-full pl-4 pr-3 py-2.5 text-sm transition-colors "
                      active-class="pastal-1"
                    >
                      {{ child.label }}
                    </router-link>
                  </li>

                </template>
              </ul>
            </li>

          </template>
        </ul>
      </nav>

      <!-- Footer -->
      <div class="p-4 border-t border-white border-opacity-20 flex-shrink-0 foot-bar dark:border-dashed">
        <button
          @click="logout"
          class="w-full flex items-center px-4 py-3  rounded-md border-none bg-transparent cursor-pointer"
          :class="{ 'justify-center': isCollapsed }"
        >
          <span class="flex items-center justify-center w-5 h-5 min-w-[1.25rem] flex-shrink-0" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </span>
          <span v-if="!isCollapsed" class="ml-3">Logout</span>
          <span v-else class="sr-only">Logout</span>
        </button>
        <!--button @click="toggleTheme" class="mt-4 p-2 bg-gray-200 dark:bg-gray-700 rounded"-->
        <button @click="toggleTheme" 
        class="w-full flex items-center px-4 py-3 rounded-md border-none bg-transparent cursor-pointer"
          :class="{ 'justify-center': isCollapsed }"
        >
         <span class="flex items-center justify-start w-5 h-5 min-w-[1.25rem] flex-shrink-0 dlogo w-full" aria-hidden="true">
          <svg class="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 21a9 9 0 0 1-.5-17.986V3c-.354.966-.5 1.911-.5 3a9 9 0 0 0 9 9c.239 0 .254.018.488 0A9.004 9.004 0 0 1 12 21Z"></path>
        </svg>
        <span v-if="!isCollapsed" class="ml-3">Dark</span>
        <span v-else class="sr-only">Dark</span>
         </span>
         <span class="flex items-center justify-start w-5 h-5 min-w-[1.25rem] flex-shrink-0 llogo w-full" aria-hidden="true">
        <svg class="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5V3m0 18v-2M7.05 7.05 5.636 5.636m12.728 12.728L16.95 16.95M5 12H3m18 0h-2M7.05 16.95l-1.414 1.414M18.364 5.636 16.95 7.05M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"></path>
        </svg>
        <span v-if="!isCollapsed" class="ml-3">Light</span>
        <span v-else class="sr-only">Light</span>
         </span>
         
        
        </button>

         <!-- User -->
      <div
        v-if="user"
        class="p-4 border-b border-white border-opacity-20 flex-shrink-0"
      >
        <div v-if="!isCollapsed" class="flex gap-2">
          <div class="me-sm-2 me-0">
            <img alt="img" width="40" height="40" class="rounded-circle" src="../../public/img/5.jpg">
          </div>
          <div class="flex flex-col">
            <p class="text-m font-medium capitalize">{{ user.username }}</p>
            <span class="text-xs text-opacity-80">
              {{ user.role }}{{ user.agentType ? " - " + user.agentType : "" }}{{ user.title && user.role === "agent" ? " · " + user.title : "" }}
            </span>
            <div
              v-if="user.role === 'agent' && user.id && user.agentType && agentTypeId"
              class="mt-1 pt-2 border-t border-white border-opacity-20 dark:border-dashed"
            >
              <AgentAvailabilityToggle
                :user-id="user.id"
                :user-agent-type-id="agentTypeId"
                class="agent-toggle-sidebar"
              />
            </div>
          </div>
        </div>

        <div v-else class="flex justify-center">
          <div
            class="w-8 h-8 rounded-full bg-white bg-opacity-20 flex items-center justify-center text-sm font-semibold"
          >
            {{ user.username.charAt(0).toUpperCase() }}
          </div>
        </div>
      </div>

      </div>
      
    </aside>

    <!-- Content -->
    <div class="sidebar-page-scroll flex-1 min-h-0 overflow-y-auto overflow-x-hidden z1">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  sidebarMenu,
  ICONS,
  pathMatches,
  canShowByRole,
  canShowMenuItem,
} from "../config/sidebarMenu.js";
import AgentAvailabilityToggle from "./AgentAvailabilityToggle.vue";
import { agentAPI } from "../services/api";

// Maps agent type string to agent_types.id (call=1, email=2, social=3 per DB insert order)
const AGENT_TYPE_IDS = { call: 1, email: 2, social: 3 };

export default {
  name: "Sidebar",
  components: { AgentAvailabilityToggle },
  props: {
    forcedCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCollapsed: false,
      openMenus: {},
    };
  },
  computed: {
    ...mapGetters(["isAdmin", "isManager", "isAgent"]),
    hasPermission() {
      return this.$store.getters.hasPermission;
    },
    user() {
      return this.$store.state.user;
    },
    userRole() {
      return this.$store.state.user?.role || null;
    },
    agentTypeId() {
      const type = this.user?.agentType;
      return type && AGENT_TYPE_IDS[type] ? AGENT_TYPE_IDS[type] : null;
    },
    visibleMenuItems() {
      return sidebarMenu.filter((item) => {
        if (item.type === "link") {
          return canShowMenuItem(
            item,
            this.hasPermission,
            this.isAdmin,
            this.userRole
          );
        }
        if (
          item.type === "group" &&
          item.permissionsAny &&
          item.permissionsAny.length
        ) {
          return item.permissionsAny.some((k) => this.hasPermission(k));
        }
        if (item.type === "group" && item.roles && item.roles.length) {
          return canShowByRole(item, this.isAdmin, this.userRole);
        }
        return true;
      });
    },
  },
  methods: {
    toggleSidebar() {
      if (this.forcedCollapsed) return;
      this.isCollapsed = !this.isCollapsed;
      if (this.isCollapsed) this.openMenus = {};
    },
    toggleMenu(id) {
      if (this.isCollapsed) return;
      this.openMenus = {
        ...this.openMenus,
        [id]: !this.openMenus[id],
      };
    },
    isMenuOpen(id) {
      return !!this.openMenus[id];
    },
    isNavLinkActive(item) {
      if (!item?.to) return false;
      const path = this.$route.path;
      if (item.pathMatch && pathMatches(path, item.pathMatch)) return true;
      if (path === item.to) return true;
      return path.startsWith(`${item.to}/`);
    },
    canShowByRole(item) {
      return canShowMenuItem(
        item,
        this.hasPermission,
        this.isAdmin,
        this.userRole
      );
    },
    visibleSectionItems(items) {
      if (!items || !Array.isArray(items)) return [];
      return items.filter((sub) =>
        canShowMenuItem(sub, this.hasPermission, this.isAdmin, this.userRole)
      );
    },
    syncOpenMenusFromRoute(path) {
      const next = { ...this.openMenus };
      sidebarMenu.forEach((item) => {
        if (
          item.type === "group" &&
          item.pathMatch &&
          pathMatches(path, item.pathMatch)
        ) {
          next[item.id] = true;
        }
      });
      this.openMenus = next;
    },
    async logout() {
      const user = this.$store.state.user;
      if (user?.role === "agent" && user?.id && this.agentTypeId) {
        try {
          await agentAPI.toggleStatus({
            user_id: user.id,
            user_agent_type_id: this.agentTypeId,
            trigger_action: "OFFLINE",
          });
        } catch (_) {
          // Proceed with logout even if set-offline fails (e.g. network)
        }
      }
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },

     toggleTheme() {
      const isDark = document.documentElement.classList.toggle('dark')
      localStorage.setItem('theme', isDark ? 'dark' : 'light')
    }
  },
  watch: {
    forcedCollapsed(newVal) {
      if (newVal) {
        // Right drawer opened -> collapse sidebar
        this.isCollapsed = true;
        this.openMenus = {};
      } else {
        // Right drawer closed -> expand sidebar back to normal
        this.isCollapsed = false;
      }
    },
    $route(to) {
      this.syncOpenMenusFromRoute(to.path);
    },
  },
  mounted() {
    this.syncOpenMenusFromRoute(this.$route.path);
  },
  created() {
    this.ICONS = ICONS;
  },

  
};

</script>


<style scoped>
.sidebar-scroll {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.4) transparent;
}

.sidebar-scroll::-webkit-scrollbar {
  width: 6px;
}

.sidebar-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.35);
  border-radius: 6px;
}

.sidebar-scroll::-webkit-scrollbar-track {
  background: transparent;
}

/* Agent availability toggle in sidebar: ensure label/error visible on dark background */
.agent-toggle-sidebar :deep(.text-gray-600) {
  color: rgba(255, 255, 255, 0.9);
}
.agent-toggle-sidebar :deep(.text-red-600) {
  color: #fca5a5;
}
</style>
